// extracted by mini-css-extract-plugin
module.exports = {"main":"DebugInfoDisplay_main__sSG9K","debugLine":"DebugInfoDisplay_debugLine__4jp6o"};